import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import anime from 'animejs';

import { Link } from '../Link';

class Component extends React.Component {
  static displayName = 'Brand';

  static propTypes = {
    theme: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    energy: PropTypes.object.isRequired,
    audio: PropTypes.object.isRequired,
    sounds: PropTypes.object.isRequired,
    className: PropTypes.any,
    link: PropTypes.string,
    hover: PropTypes.bool,
    stableTime: PropTypes.bool,
    onEnter: PropTypes.func,
    onExit: PropTypes.func,
    onLinkStart: PropTypes.func,
    onLinkEnd: PropTypes.func
  };

  static defaultProps = {
    link: '/'
  };

  constructor () {
    super(...arguments);

    const { energy, stableTime } = this.props;

    if (!stableTime) {
      energy.updateDuration({ enter: 820 });
    }
  }

  componentWillUnmount () {
    const paths = this.svgElement.querySelectorAll('path');
    anime.remove(paths);
  }

  enter () {
    const { energy, sounds, stableTime, onEnter } = this.props;
    const paths = this.svgElement.querySelectorAll('path');

    anime.set(this.svgElement, { opacity: 1 });

    sounds.logo.play();

    anime({
      targets: paths,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'linear',
      delay: (path, index) => stableTime ? 0 : index * energy.duration.stagger,
      duration: path => stableTime ? energy.duration.enter : path.getTotalLength(),
      complete: () => {
        onEnter && onEnter();
      }
    });
  }

  exit () {
    const { energy, sounds, onExit } = this.props;
    const paths = this.svgElement.querySelectorAll('path');

    sounds.fade.play();

    anime({
      targets: this.svgElement,
      easing: 'easeInCubic',
      duration: energy.duration.exit,
      opacity: 0
    });
    anime({
      targets: paths,
      strokeDashoffset: [anime.setDashoffset, 0],
      easing: 'linear',
      direction: 'reverse',
      duration: energy.duration.exit,
      complete: () => {
        anime.set(this.svgElement, { opacity: 0 });
        onExit && onExit();
      }
    });
  }

  render () {
    const {
      theme,
      classes,
      energy,
      audio,
      sounds,
      className,
      link,
      hover,
      stableTime,
      onEnter,
      onExit,
      onLinkStart,
      onLinkEnd,
      ...etc
    } = this.props;

    return (
      <h1 className={cx(classes.root, hover && classes.hover, className)} {...etc}>
        <Link
          className={classes.link}
          href={link}
          title='Back to homepage'
          onLinkStart={onLinkStart}
          onLinkEnd={onLinkEnd}
        >
          <span className={classes.title}>EleksyonPH</span>
<svg
  ref={ref => (this.svgElement = ref)}
  className={classes.svg}
  viewBox="0 0 1400 92"
  xmlns="http://www.w3.org/2000/svg"
  onMouseEnter={() => sounds.hover.play()}
>
  <style>
    {`.${classes.path} { 
      fill: none; 
      stroke: currentColor; 
      stroke-width: 12; 
      stroke-linecap: round; 
      stroke-linejoin: round; 
    }`}
  </style>

  {/* E — +30 → now at x=100 */}
  <path className={classes.path} d="
    M 100,20 L 100,80
    L 190,80
    M 100,20 L 190,20
    M 100,50 L 170,50
  " />

  {/* L — +30 → x=230 */}
  <path className={classes.path} d="
    M 230,20 L 230,80
    L 310,80
  " />

  {/* E — +30 → x=350 */}
  <path className={classes.path} d="
    M 350,20 L 350,80
    L 440,80
    M 350,20 L 440,20
    M 350,50 L 420,50
  " />

  {/* K — +30 → x=480 */}
  <path className={classes.path} d="
    M 480,20 L 480,80
    M 480,50 L 550,20
    M 480,50 L 550,80
  " />

  {/* S — +30 → now centered at x=665 */}
  <path className={classes.path} d="
    M 665,30
    Q 635,20 645,20
    Q 595,20 595,35
    Q 595,50 625,50
    Q 665,50 665,65
    Q 665,80 645,80
    Q 595,80 595,70
  " />

  {/* Y — +30 → x=700 */}
  <path className={classes.path} d="
    M 700,20 L 740,50
    L 780,20
    M 740,50 L 740,80
  " />

  {/* O — +30 → now centered at x=850 */}
  <path className={classes.path} d="
    M 880,50
    A 35,30 0 1 0 810,50
    A 35,30 0 1 0 880,50
    Z
  " />

  {/* N — +30 → x=920 */}
  <path className={classes.path} d="
    M 920,80 L 920,20
    L 1000,80
    L 1000,20
  " />

  {/* P — +30 → x=1040 */}
  <path className={classes.path} d="
    M 1040,80 L 1040,20
    L 1120,20
    Q 1140,20 1140,35
    Q 1140,50 1120,50
    L 1040,50
  " />

  {/* H — +30 → x=1170 */}
  <path className={classes.path} d="
    M 1170,20 L 1170,80
    M 1250,20 L 1250,80
    M 1170,50 L 1250,50
  " />
</svg>
        </Link>
      </h1>
    );
  }
}

export { Component };
